import { SvgIcon, SxProps } from "@mui/material";
import ReactionLaughSvg from "jsx:../../../Images/Icons/Custom/reactionLaugh.svg";

export function ReactionLaughIcon(props: SxProps) {
    return <SvgIcon component={ReactionLaughSvg} inheritViewBox sx={props} />;
}
